/**
 * Created by Mike Naughton on 9/7/17.
 *
 * A factory for creating MapServiceBase instances
 */

import InternalMapService from "app/models/map/InternalMapService";
import ExternalMapService from "app/models/map/ExternalMapService";
import _ from "underscore";
import urlService from "app/UrlService";

export default {
  /**
   * Generates a `MapServiceBase` instance from a given `MapService` model.
   * @param  {MapService}   serviceModel The model from which to generate the instance.
   * @param  {Function} [cb]           A function which shall expect two arguments. The first is an error, if any, and the second is the `MapServiceBase` which was generated, if the operation was successful.
   * @return {MapServiceBase}                If `cb` is not specified, the `MapServiceBase` that was created.
   */
  createService: function (serviceModel, cb) {
    var MapServiceImpl;

    if (serviceModel.get("external")) {
      MapServiceImpl = ExternalMapService;
    } else {
      MapServiceImpl = InternalMapService;
    }

    var service = new MapServiceImpl({
      service: serviceModel,
      name: serviceModel.get("name"),
      visible: serviceModel.get("defaultVisibility"),
    });

    if (_.isFunction(cb)) {
      return cb(null, service);
    } else {
      return service;
    }
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/map/ServiceFactory.js
// module id = 353
// module chunks = 1